import React, { useState } from "react";
import { Avatar, Dropdown, Tag } from "antd";
import { MoreOutlined, RightOutlined, DownOutlined } from "@ant-design/icons";
import { displayPhone, displayEmail } from "../engagementHelpers";
import { openDialog } from "../../../../library/helpers";
import { DIALOG_TYPES } from "../../../hoc/Dialog/dialog";
import { ANTD_MODAL_OPEN_POSITION } from "../../../../library/constants";
import PhoneSvg from "../../../../icons/svg/call.svg";
import EmailSvg from "../../../../icons/svg/email.svg";
import CoBuyerDetailDrawer from "./CoBuyerDetailDrawer";

const CoBuyerCard = ({ coBuyer, onDelete }) => {
  const [expanded, setExpanded] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editDrawerOpen, setEditDrawerOpen] = useState(false);
  const lead = coBuyer?.lead || {};
  const { firstName, lastName } = lead;

  const phone = displayPhone(lead);
  // Show email only if phone is not available
  const email = phone === "N/A" ? displayEmail(lead) : null;

  const menuItems = [
    { key: "edit", label: "Edit" },
    { key: "delete", label: "Delete", danger: true },
  ];

  const handleMenuClick = ({ key }) => {
    if (key === "edit") setEditDrawerOpen(true);
    if (key === "delete") {
      openDialog(DIALOG_TYPES.NEW_CONFIRM_DIALOG, {
        dialogHeader: "Delete co-buyer",
        headerLine1: "Are you sure you want to Remove Co-Buyer?",
        headerLine2: "This won't delete the contact from your CRM.",
        onOk: async () => {
          onDelete?.(coBuyer);
        },
        centered: ANTD_MODAL_OPEN_POSITION,
        isDanger: true,
        okBtnText: "Yes, Delete",
      });
    }
  };

  return (
    <div className="flex flex-col w-full">
      <div className="flex items-center gap-3 w-full justify-between">
        <Avatar style={{ backgroundColor: "#FB7185" }} size={32}>
          {firstName?.[0]}
          {lastName?.[0]}
        </Avatar>
        <div className="flex-1">
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
          <p
            className="mb-1 text-sm text-twLinkColor font-semibold cursor-pointer"
            onClick={() => setDrawerOpen(true)}
          >
            {firstName} {lastName}
          </p>
          <Tag>Co-Buyer</Tag>
        </div>
        <div className="flex items-center gap-2 self-start">
          {/* <Dropdown menu={{ items: menuItems, onClick: handleMenuClick }} trigger={["click"]}>
            <div
              className="cursor-pointer flex items-center justify-center"
              onClick={e => e.stopPropagation()}
            >
              <MoreOutlined className="icon-color text-base" />
            </div>
          </Dropdown> */}
          <div
            className="cursor-pointer flex items-center justify-center"
            style={{ width: 24, height: 24 }}
            onClick={() => setExpanded(prev => !prev)}
          >
            {expanded ? (
              <DownOutlined className="icon-color text-base" />
            ) : (
              <RightOutlined className="icon-color text-base" />
            )}
          </div>
        </div>
      </div>
      <div
        className="flex flex-col gap-2 text-sm overflow-hidden transition-all duration-300 ease-in-out"
        style={{
          maxHeight: expanded ? 200 : 0,
          opacity: expanded ? 1 : 0,
          marginTop: expanded ? 8 : 0,
        }}
      >
        {phone !== "N/A" ? (
          <div className="flex items-center gap-2">
            <img src={PhoneSvg} alt="phone" />
            <span className="text-[#334155] text-sm font-normal">{phone}</span>
          </div>
        ) : email && email !== "N/A" ? (
          <div className="flex items-center gap-2">
            <img className="mt-1" src={EmailSvg} alt="email" />
            <span className="text-[#334155] text-sm font-normal">{email}</span>
          </div>
        ) : (
          <span className="text-black-45 text-sm font-normal">No contact details</span>
        )}
      </div>
      {drawerOpen && (
        <CoBuyerDetailDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          coBuyer={coBuyer}
        />
      )}
      {editDrawerOpen && (
        <CoBuyerDetailDrawer
          open={editDrawerOpen}
          onClose={() => setEditDrawerOpen(false)}
          coBuyer={coBuyer}
          isEdit
          onSave={values => {
            setEditDrawerOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default CoBuyerCard;
